import { Head, usePage, Deferred, Link } from '@inertiajs/react'
import { Button } from "@/components/ui/button"
import { ColumnDef, Row } from "@tanstack/react-table"
import { FlashMessage } from '@/components/flash-message'
import { SortableHeader } from '@/components/sortable-header'
import { FilteredTable } from '@/components/ui/filtered-table'

interface User {
  id: number
  name: string
  email: string
  role: string
}

interface Props {
  users: User[]
  [key: string]: any
}

const columns: ColumnDef<User>[] = [
  {
    accessorKey: "name",
    header: ({ column }) => <SortableHeader column={column} title="Name" />,
    enableSorting: true,
  },
  {
    accessorKey: "email",
    header: ({ column }) => <SortableHeader column={column} title="Email" />,
    enableSorting: true,
  },
  {
    accessorKey: "role",
    header: ({ column }) => <SortableHeader column={column} title="Role" />,
    enableSorting: true,
    cell: ({ row }) => {
      const role = row.getValue("role") as string
      return role.charAt(0).toUpperCase() + role.slice(1)
    }
  },
  {
    id: "actions",
    cell: ({ row }: { row: Row<User> }) => {
      const user = row.original;
      return (
        <div className="flex items-center gap-2">
          <Link href={`/users/${user.id}`}>
            <Button variant="outline" size="sm">
              View
            </Button>
          </Link>
        </div>
      );
    },
  }
]

export default function Index() {
  const { users } = usePage<Props>().props

  return (
    <>
      <Head title="Users" />
      <div className="space-y-4 pt-4 px-6">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold">Users</h1>
        </div>
      </div>

      <FlashMessage />

      <div className="p-6">
        <Deferred data="users" fallback={<div>Loading...</div>}>
          <FilteredTable
            data={users}
            columns={columns}
            searchPlaceholder="Search users..."
          />
        </Deferred>
      </div>
    </>
  )
} 